var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 2.49902C17.5233 2.49902 22.0011 6.97687 22.0011 12.5006C22.0011 18.0243 17.5233 22.5021 11.9996 22.5021C6.47589 22.5021 1.99805 18.0243 1.99805 12.5006C1.99805 6.97687 6.47589 2.49902 11.9996 2.49902ZM11.9958 10.7496C11.483 10.7499 11.0605 11.1363 11.0031 11.6336L10.9964 11.7503L11 17.2519L11.0068 17.3685C11.0649 17.8658 11.4879 18.2515 12.0007 18.2512C12.5135 18.2509 12.936 17.8645 12.9934 17.3672L13 17.2505L12.9964 11.749L12.9896 11.6323C12.9316 11.135 12.5086 10.7493 11.9958 10.7496ZM12 7.00006C11.3089 7.00006 10.7485 7.56038 10.7485 8.25158C10.7485 8.94277 11.3089 9.5031 12 9.5031C12.6912 9.5031 13.2516 8.94277 13.2516 8.25158C13.2516 7.56038 12.6912 7.00006 12 7.00006Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.354a251822a35729e4893c4003ebcff5.svg";
export { ForwardRef as ReactComponent };